import { PaymentMethod } from '@repo/common';
import { useRef } from 'react';
import { useParams } from 'react-router-dom';
import { toast } from 'sonner';

import {
    useAddSupplierPaymentMutation,
    useGetSupplierByIdQuery,
} from '@/features/slice/suppliers';

import { IwFormRef } from '../../../components/form';
import { toastError } from '../../../utils';
import { TAddPaymentForm } from '../../cart/add-payment-form.schema';

export const useSupplierDetails = () => {
    const params = useParams();
    const id = params.id || '';
    const { data, error, isLoading, isError } = useGetSupplierByIdQuery(id);

    const paymentFormRef = useRef<IwFormRef<TAddPaymentForm>>(null);

    const [addSupplierPayment, { isLoading: isPaymentLoading }] =
        useAddSupplierPaymentMutation();

    const handleAddSupplierPayment = async (payload: TAddPaymentForm) => {
        console.log(paymentFormRef);
        try {
            await addSupplierPayment({
                id,
                amount: payload.payments?.[0]?.amount || 0,
                payment_method: payload.payments?.[0]?.payment_method || '',
                transaction_id: payload.payments?.[0]?.transaction_id || '',
            }).unwrap();
            paymentFormRef.current?.setValue('payments', [
                {
                    amount: 0,
                    payment_method: PaymentMethod.CASH,
                    transaction_id: '',
                },
            ]);
            toast.success('Payment added successfully');
        } catch (error) {
            toastError(error, 'useSupplierDetails:handleAddSupplierPayment');
        }
    };

    return {
        data,
        error,
        isLoading,
        isError,
        supplierId: id,
        handleAddSupplierPayment,
        isPaymentLoading,
        paymentFormRef,
    };
};
